<template>
  <b-overlay
    :show="show"
    variant="dark"
    no-wrap
    @shown="$refs.dialog.focus()">
    <template #overlay>
      <div
        ref="dialog"
        tabindex="-1"
        role="dialog"
        aria-modal="false"
        style="outline: none; color: white;"
        aria-labelledby="form-confirm-label">
        <p style="font-size: larger; text-align: center;">
          <strong
            id="form-confirm-label"
            class="text-capitalize">{{ msg }}</strong>
        </p>
        <div class="d-flex justify-content-center">
          <b-button
            variant="danger"
            class="mr-3"
            @click="$emit('onCancel')">
            Cancel
          </b-button>
          <b-button
            variant="success"
            @click="$emit('onConfirm')">
            Yes
          </b-button>
        </div>
      </div>
    </template>
  </b-overlay>
</template>

<script>
export default {
  name: "PaywallOverlay",
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    msg: {
      type: String,
      default: "",
      required: true,
    },
  },
}
</script>

<style scoped>

</style>